import { colors } from '@lmc/common/constants'
import type { Resident, User } from '@lmc/ts-common'
import dayjs from 'dayjs'
import _ from 'lodash'
import { type FC, type ReactNode, useEffect, useState } from 'react'
import { postJSON } from '../../../common/services/api'

type Props = { user?: User; residents?: Resident[] }

const HomeTitle: FC<Props> = ({ user, residents }) => {
  const [birthdayBoysNGirls, setBirthdayBoysNGirls] = useState<
    null | Resident[]
  >()

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (residents) {
      if (!user?.firstLogin) {
        // TODO: remove this. Don't mutate the state object directly
        // @ts-ignore
        user.firstLogin = dayjs() // avoid it being triggered every time you log in.
        postJSON({ url: 'reports/user/firstlogin' })
      }

      const birthdayBoysNGirls = _.sortBy(
        residents.filter(
          (res: Resident) =>
            res.dateOfBirth &&
            dayjs(res.dateOfBirth).format('MM/DD') === dayjs().format('MM/DD')
        ),
        'name.first'
      )

      setBirthdayBoysNGirls(birthdayBoysNGirls)
    }
  }, [])

  const renderBirthdays = (greeting: ReactNode, residents: Resident[]) => {
    if (residents.length === 1) {
      const age = dayjs().diff(residents[0].dateOfBirth, 'years')
      const displayName =
        residents[0]?.preferredName ||
        `${residents[0].name.first} ${residents[0].name.last}`
      return (
        <span>
          {greeting} don`t forget to say happy birthday to{' '}
          <strong>{displayName}</strong>, who`s turning {age}!
        </span>
      )
    }
    const names = residents.reduce(
      (prev: string, next: Resident, index: number) => {
        if (index === residents.length - 1) {
          return `${prev} and ${next.name.first}`
        }
        if (prev !== '') {
          return `${prev}, ${next.name.first}`
        }
        return next.name.first
      },
      ''
    )

    return (
      <span>
        {greeting} don`t forget to say happy birthday to {names}!
      </span>
    )
  }

  const renderMessages = () => {
    const userName =
      user?.name && user.name.first && user.name.first.split(' ').length > 1
        ? user?.name.first.split(' ')[0]
        : user?.name.first

    const initialGreeting = <span style={styles.bold}>Hey {userName},</span>

    if (birthdayBoysNGirls?.length) {
      return renderBirthdays(initialGreeting, birthdayBoysNGirls)
    }
    return null
  }

  if (!birthdayBoysNGirls || !birthdayBoysNGirls.length) return null

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{renderMessages()}</h2>
    </div>
  )
}

const styles = {
  container: {
    padding: 0
  },
  title: {
    fontSize: 20,
    color: colors.red
  },
  bold: {
    fontWeight: 'bold'
  }
}

export default HomeTitle
